<template>
    <div class="push-config">
        <div v-for="(row, index) in pushConditionsData" :key="index" class="pc-row">
            <!-- 逻辑符（非首项） -->
            <el-select v-if="row.tempLogicalOperator" v-model="row.tempLogicalOperator.operator" class="pc-w-100"
                size="small">
                <el-option v-for="op in logicalOperatorOptions" :key="op.value" :label="op.label" :value="op.value" />
            </el-select>

            <!-- 条件类型 -->
            <el-select v-model="row.pushConditions.dataType" class="pc-w-120" size="small"
                @change="changeDataType(row)">
                <el-option v-for="dt in dataTypeOptions" :key="dt.value" :label="dt.label" :value="dt.value" />
            </el-select>

            <!-- 运算符 -->
            <el-select
                v-if="(pushConditionsConfig[row.pushConditions.dataType] && pushConditionsConfig[row.pushConditions.dataType].compareOperators && pushConditionsConfig[row.pushConditions.dataType].compareOperators.length)"
                v-model="row.pushConditions.operator" class="pc-w-110" size="small">
                <el-option v-for="op in pushConditionsConfig[row.pushConditions.dataType].compareOperators" :key="op"
                    :label="compareLabel(op)" :value="op" />
            </el-select>

            <!-- models：渠道/角色/版本/使用天数 -->
            <template v-if="hasModels(row)">
                <!-- APP_VERSION / USAGE_DAY：多选下拉 -->
                <el-select v-if="isMultiModel(row)" v-model="row.pushConditions.values" multiple filterable
                    class="pc-flex" size="small">
                    <el-option v-for="m in pushConditionsConfig[row.pushConditions.dataType].models" :key="m.value"
                        :label="m.label" :value="m.value" />
                </el-select>

                <!-- CHANNEL / USER_ROLE：全选 or 指定 -->
                <div v-else class="pc-flex pc-specified">
                    <el-radio-group v-model="row.tempSelectModel" class="pc-radio">
                        <el-radio label="all">全选</el-radio>
                        <el-radio label="specified">指定</el-radio>
                    </el-radio-group>
                    <el-select v-model="row.pushConditions.values" multiple filterable class="pc-flex" size="small"
                        :disabled="row.tempSelectModel !== 'specified'">
                        <el-option v-for="m in specifiedList(row)" :key="m.value" :label="m.label" :value="m.value" />
                    </el-select>
                </div>
            </template>

            <!-- 指定人群 uid -->
            <el-input v-if="row.pushConditions.dataType === ConditionsDataTypeEnum.USER" v-model="row.tempUsers"
                class="pc-flex" size="small" placeholder="添加多个请用;符号隔开" @input="syncUserValues(row)" />

            <!-- 操作 -->
            <div class="pc-actions">
                <span
                  v-if="pushConditionsData.length > 1"
                  class="pc-action-btn pc-action-del"
                  title="删除"
                  @click="deletePushConditionsData(index)"
                >
                  −
                </span>
                <span
                  v-if="index === pushConditionsData.length - 1"
                  class="pc-action-btn pc-action-add"
                  title="新增"
                  @click="addPushConditionsData()"
                >
                  +
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {
    createPushConditionsStore,
    LogicalOperators,
    CompareOperators,
    ConditionsDataTypeEnum,
    LogicalOperatorsMap,
    CompareOperatorsMap,
    ConditionsDataTypeMap
} from "./usePushConditions";

export default {
    name: "PushConfig",
    data() {
        return {
            // store fields injected by createPushConditionsStore
            pushConditionsConfig: {},
            pushConditionsData: []
        };
    },
    computed: {
        ConditionsDataTypeEnum() {
            return ConditionsDataTypeEnum;
        },
        logicalOperatorOptions() {
            return Object.values(LogicalOperators).map((v) => ({
                value: v,
                label: LogicalOperatorsMap[v]
            }));
        },
        dataTypeOptions() {
            return Object.values(ConditionsDataTypeEnum).map((v) => ({
                value: v,
                label: ConditionsDataTypeMap[v]
            }));
        }
    },
    mounted() {
        createPushConditionsStore(this);
        this.initPushConditionsConfig();
    },
    methods: {
        compareLabel(op) {
            return CompareOperatorsMap[op] || op;
        },
        hasModels(row) {
            const cfg = this.pushConditionsConfig[row.pushConditions.dataType];
            return cfg && cfg.models && cfg.models.length;
        },
        isMultiModel(row) {
            return [ConditionsDataTypeEnum.APP_VERSION, ConditionsDataTypeEnum.USAGE_DAY].includes(
                row.pushConditions.dataType
            );
        },
        specifiedList(row) {
            const cfg = this.pushConditionsConfig[row.pushConditions.dataType];
            if (!cfg || !cfg.models) return [];
            const specified = cfg.models.find((m) => m.value === "specified");
            return (specified && specified.list) ? specified.list : [];
        },
        syncUserValues(row) {
            row.pushConditions.values = row.tempUsers
                ? String(row.tempUsers)
                    .split(";")
                    .map((v) => v.trim())
                    .filter(Boolean)
                : [];
        },
        // ===== expose =====
        getData() {
            return this.getConditionsData();
        },
        initData(data) {
            this.initPushConditionsData(data);
        }
    }
};
</script>

<style scoped>
.push-config {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.pc-row {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    overflow: hidden;
}

.pc-w-100 {
    width: 100px;
}

.pc-w-110 {
    width: 110px;
}

.pc-w-120 {
    width: 120px;
}

.pc-flex {
    flex: 1;
    min-width: 0;
}

.pc-actions {
  width: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.pc-action-btn {
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 2px;
  font-weight: 700;
  cursor: pointer;
  user-select: none;
}

.pc-action-add {
  background: #67c23a;
  color: #fff;
}

.pc-action-del {
  background: #f56c6c;
  color: #fff;
}

.pc-specified {
    display: flex;
    align-items: center;
    gap: 8px;
}

.pc-radio {
    flex-shrink: 0;
}
</style>
